import React, { useState } from 'react';
import { Alert, Button, Empty, Select, Spin } from 'antd';
import AiDraftCard from './AiDraftCard';
import { useApiRequest } from '../../hooks/useApiRequest';
import { useResource } from '../../hooks/useResource';
import { userMessageForError } from '../../utils/apiError';
import { DRAFT_STATE_FILTERS } from '../../utils/questionBankCuratorModel';

/**
 * Every AI draft for the selected standard, filtered server-side by state. This is where the human
 * approval event of Commandment IV is given (or the draft is rejected / corrected first).
 */
const ReviewPanel = ({ standardId, rev, onChanged }) => {
    const { request } = useApiRequest();
    const [state, setState] = useState('AI_DRAFT');

    const drafts = useResource(
        async () => (await request('GET', '/admin/question-bank/ai-drafts', {
            query: { standardId, state: state === 'ALL' ? undefined : state },
        })).data.drafts || [],
        [request, standardId, state, rev],
    );

    return (
        <div>
            <div style={{ marginBottom: 12 }}>
                <Select
                    aria-label="Draft state"
                    style={{ width: 260 }}
                    value={state}
                    onChange={(v) => setState(v || 'AI_DRAFT')}
                    options={DRAFT_STATE_FILTERS}
                />
            </div>
            {drafts.status === 'loading' && !drafts.data && <Spin />}
            {drafts.status === 'error' && (
                <Alert type="error" message={userMessageForError(drafts.error)} action={<Button size="small" onClick={drafts.reload}>Retry</Button>} />
            )}
            {drafts.data && drafts.data.length === 0 && (
                <Empty description={state === 'AI_DRAFT' ? 'No AI drafts are waiting for review for this standard.' : 'No AI drafts in this state for this standard.'} />
            )}
            {drafts.data && drafts.data.map((d) => (
                <AiDraftCard key={d.id} draft={d} standardId={standardId} onChanged={onChanged} />
            ))}
        </div>
    );
};

export default ReviewPanel;
